import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { getTaxon } from './taxonomyDatabase';
import { getSpecimenFeatures, type FeatureValue } from './specimenFeatures';

interface ComparisonViewProps { firstId: string; secondId: string; observed: Record<string, Record<string, FeatureValue>>; }

const ComparisonView: React.FC<ComparisonViewProps> = ({ firstId, secondId, observed }) => {
  const firstTaxon = getTaxon(firstId); const secondTaxon = getTaxon(secondId);
  const firstFeatures = getSpecimenFeatures(firstId).features; const secondFeatures = getSpecimenFeatures(secondId).features;
  const ids = Array.from(new Set([...firstFeatures.map((item) => item.id), ...secondFeatures.map((item) => item.id)]));
  const value = (specimenId: string, features: typeof firstFeatures, id: string) => {
    if (observed[specimenId]?.[id] !== undefined) return String(observed[specimenId][id]);
    return String(features.find((item) => item.id === id)?.value ?? 'not recorded');
  };
  return <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 1 }}>
    <Typography variant="subtitle1" fontWeight={800}>Specimen comparison</Typography>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mt: 1 }}>
      {[{ taxon: firstTaxon, id: firstId, features: firstFeatures }, { taxon: secondTaxon, id: secondId, features: secondFeatures }].map(({ taxon, id, features }) => <Box key={id} sx={{ flex: 1, minWidth: 0 }}><Typography variant="subtitle2" fontWeight={800}>{taxon.commonName}</Typography><Typography variant="caption"><i>{taxon.scientificName}</i></Typography>{ids.map((featureId) => <Typography key={featureId} variant="caption" display="block">{featureId}: {value(id, features, featureId).replaceAll('-', ' ')}</Typography>)}</Box>)}
    </Stack>
  </Paper>;
};

export default ComparisonView;
